// A set of distinct, playful emojis for CPU players
const CPU_AVATARS = ['🤖', '🐼', '🦊', '🦉', '🐲', '🐙', '👾', '👻', '🧙‍♂️', '🦁'];

// Distinct gradient backgrounds for CPU players
const CPU_GRADIENTS = [
  'linear-gradient(135deg, #4a1a6b, #9b59b6)', // Default Purple
  'linear-gradient(135deg, #1e3c72, #2a5298)', // Deep Blue
  'linear-gradient(135deg, #093028, #237a57)', // Deep Green
  'linear-gradient(135deg, #870000, #190a05)', // Dark Red
  'linear-gradient(135deg, #b06ab3, #4568dc)', // Pinkish Blue
  'linear-gradient(135deg, #cc2b5e, #753a88)', // Magenta
];

/**
 * Returns a consistent emoji for a CPU player based on their ID or name
 */
export function getCPUAvatar(cpuNameOrId) {
  if (!cpuNameOrId) return '🤖';
  // Simple hash
  let hash = 0;
  for (let i = 0; i < cpuNameOrId.length; i++) {
    hash = cpuNameOrId.charCodeAt(i) + ((hash << 5) - hash);
  }
  const index = Math.abs(hash) % CPU_AVATARS.length;
  return CPU_AVATARS[index];
}

/**
 * Returns a consistent gradient string for a CPU player based on their ID or name
 */
export function getCPUGradient(cpuNameOrId) {
  if (!cpuNameOrId) return CPU_GRADIENTS[0];
  let hash = 0;
  for (let i = 0; i < cpuNameOrId.length; i++) {
    hash = cpuNameOrId.charCodeAt(i) + ((hash << 5) - hash);
  }
  // Offset hash slightly to maybe mix & match differently than avatar
  const index = Math.abs(hash * 3) % CPU_GRADIENTS.length;
  return CPU_GRADIENTS[index];
}
